var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30769 10.2938V7.90957H1.76923C1.56522 7.90957 1.36956 7.82283 1.2253 7.66844C1.08104 7.51404 1 7.30464 1 7.08629V1.32329C1 1.10494 1.08104 0.895531 1.2253 0.741135C1.36956 0.586739 1.56522 0.5 1.76923 0.5H10.2308C10.4348 0.5 10.6304 0.586739 10.7747 0.741135C10.919 0.895531 11 1.10494 11 1.32329V7.08629C11 7.30464 10.919 7.51404 10.7747 7.66844C10.6304 7.82283 10.4348 7.90957 10.2308 7.90957H6L3.63615 10.4395C3.60926 10.4684 3.57496 10.4881 3.53761 10.496C3.50026 10.504 3.46154 10.4999 3.42636 10.4843C3.39118 10.4687 3.36112 10.4423 3.33999 10.4084C3.31887 10.3744 3.30762 10.3346 3.30769 10.2938Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30756 5.44056H8.69217M3.30756 2.9707H8.69217",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/Message_Icon.17e6c87b51a66b223994a4c7af56b890.svg";
export { ForwardRef as ReactComponent };